
import { Users, Cog, Shield } from "lucide-react";
import { MegaMenuItem } from "./MegaMenuItem";
import { Link } from "react-router-dom";

interface ServicesMenuProps {
  isOpen: boolean;
}

export const ServicesMenu = ({ isOpen }: ServicesMenuProps) => {
  return (
    <nav 
      className={`${isOpen ? 'block' : 'hidden'} absolute top-full left-1/2 transform -translate-x-1/2 mt-3 w-[600px] bg-white rounded-xl shadow-xl border border-gray-100 p-8 grid grid-cols-1 gap-8`}
      aria-label="Services navigation"
      aria-hidden={!isOpen}
    >
      <Link to="/services/cybersecurity-advisory" aria-label="Learn about Cybersecurity Advisory services">
        <MegaMenuItem
          icon={Users}
          title="Cybersecurity Advisory"
          description="Contain the security chaos holding you back. Our strategic guidance, vCISO expertise, and GRC solutions transform uncertainty into business growth."
        />
      </Link>
      <Link to="/services/managed-cybersecurity" aria-label="Learn about Managed Cybersecurity Services">
        <MegaMenuItem
          icon={Shield}
          title="Managed Cybersecurity Services"
          description="Comprehensive protection for your digital assets. Our managed cybersecurity services provide continuous monitoring, threat detection, and incident response."
        />
      </Link>
      <Link to="/services/managed-services" aria-label="Learn about Managed IT Services">
        <MegaMenuItem
          icon={Cog}
          title="Managed IT Services"
          description="Experience IT that grows with you. Our managed services align with your business goals, eliminating complexity while driving growth through strategic technology management."
        />
      </Link>
    </nav>
  );
};
